import { useNuxtApp } from "#app"
import { useProductStore } from "~/stores/ProductStore"
import { useCartStore } from "~/stores/CartStore"
import { useSettingsStore } from "~/stores/SettingsStore"
import Product from "~/models/Product"
import { storeToRefs } from "pinia"

export default defineNuxtPlugin((nuxtApp) => {
	const { $productsApiService, $apiHelper, $utilities } = useNuxtApp()
	const productStore = useProductStore()
	const cartStore = useCartStore()
	const settingsStore = useSettingsStore()
	const { cartId, exchangeRate } = storeToRefs(cartStore)

	nuxtApp.provide("productsService", {
		$getProductByIdOrSku: async (productIdOrSku) => {
			const productsExchangeRate = cartId.value ? exchangeRate.value : null
			const { data, pending, status } = await $productsApiService.$getProductByIdOrSku(
				productIdOrSku,
				productsExchangeRate
			)

			$apiHelper.$handleResponse(pending, status, data, (productData) => {
				const product = Product.createFromPartial(productData.product)
				productStore.addProduct(product)
			})
		},

		$getProductsByType: async (productTypeId) => {
			const productsExchangeRate = cartId.value ? exchangeRate.value : null
			$utilities.$startDetectingSlowConnection()
			settingsStore.addFetchingProduct(productTypeId)

			//Automatically set the flag to false after 1 minute of fetching
			//Not ideal to use a timeout here, the apiHelper should be refactored to accept an error callback
			const SLOW_NETWORK_TIMEOUT = setTimeout(() => {
				settingsStore.removeFetchingProduct(productTypeId)
			}, 60000)

			const { data, pending, status } = await $productsApiService.$getProductsByType(
				productTypeId,
				productsExchangeRate
			)

			$apiHelper.$handleResponse(pending, status, data, (productData) => {
				$utilities.$finishDetectingSlowConnection()
				settingsStore.removeFetchingProduct(productTypeId)
				clearTimeout(SLOW_NETWORK_TIMEOUT)

				productStore.removeProductsByTypeId(productTypeId)
				productData.products.forEach((item) => {
					const product = Product.createFromPartial(item)
					productStore.addProduct(product)
				})
			})
		},

		$getAppSettings: async () => {
			$utilities.$startDetectingSlowConnection()
			const { data, pending, status } = await $productsApiService.$getAppSettings()

			$apiHelper.$handleResponse(pending, status, data, (data) => {
				$utilities.$finishDetectingSlowConnection()
				settingsStore.setMaxInstallmentCount(data.maxInstallmentCount)
			})
		},
	})
})
